// src/components/Layout/Header.js

import React, { useState } from "react";
import ContactDialog from "../../features/contact/ContactDialog";
import { isMapsRoute } from "../../shared/navigation/mapsRoutes";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Bars3Icon } from "@heroicons/react/24/outline";

function Header({ toggleSidebar, handleReset, isSidebarOpen = false }) {
  const [contactOpen, setContactOpen] = useState(false);
  const location = useLocation();
  const boePage = location.pathname === '/boe' || (location.pathname === '/budget-vs-spent' && (new URLSearchParams(location.search).get('context') || location.state?.budgetContext) === 'boe');
  const mapsPage = isMapsRoute(location.pathname);
  const townPage =
    (location.pathname === "/budget-vs-spent" && (new URLSearchParams(location.search).get('context') || location.state?.budgetContext) !== "boe");
  return (
    <header className="w-full bg-gray-900 px-4 py-3 shadow z-40 xl:pl-64">
      <div className="flex items-center justify-between xl:justify-start relative">
        {/* Left: Hamburger (mobile only) */}
        <div className="flex items-center xl:mr-4">
          <button
            onClick={toggleSidebar}
            className="xl:hidden p-2 text-white hover:bg-gray-800 rounded"
            aria-label="Toggle sidebar"
            aria-expanded={isSidebarOpen}
            aria-controls="site-sidebar"
          >
            <Bars3Icon className="h-6 w-6" />
          </button>
        </div>

        {/* Property Star Branding */}
        <div className="absolute left-1/2 -translate-x-1/2 xl:static xl:translate-x-0">
          <Link
            to="/"
            onClick={handleReset}
            data-testid="property-title-button"
            className="flex items-center gap-2 text-xl font-bold text-white hover:text-primary bg-transparent border-none p-0 m-0 cursor-pointer no-underline"
            title="Go to home page"
          >
            {/* Mobile: simple title */}
            <span className="flex items-center gap-2 xl:hidden">Glastonbury Data</span>
            <span className="sr-only hidden xl:inline">Glastonbury Data home</span>
          </Link>
        </div>

        {/* Nav Links — aligned with sidebar (starts at left-64) */}
        <nav aria-label="Main navigation" className="hidden xl:flex flex-wrap ml-0 pl-5 gap-2 font-medium">
          <NavLink
            to="/budget"
            className={({ isActive }) =>
              `rounded-t-lg px-4 py-2 text-sm ${
                (isActive || townPage)
                  ? "bg-white text-gray-900 shadow font-semibold"
                  : "bg-gray-700 text-white hover:bg-gray-600"
              }`
            }
          >
            Town of Glastonbury
          </NavLink>

          <NavLink
            to="/reports"
            className={({ isActive }) =>
              `rounded-t-lg px-4 py-2 text-sm ${
                (isActive || boePage)
                  ? "bg-white text-gray-900 shadow font-semibold"
                  : "bg-gray-700 text-white hover:bg-gray-600"
              }`
            }
          >
            Board of Education
          </NavLink>


          <Link
            to="/maps"
            aria-current={mapsPage ? "page" : undefined}
            className={`rounded-t-lg px-4 py-2 text-sm ${mapsPage
              ? "bg-white text-gray-900 shadow font-semibold"
              : "bg-gray-700 text-white hover:bg-gray-600"}`}
          >
            Maps
          </Link>

          <NavLink
            to="/elections"
            className={({ isActive }) =>
              `rounded-t-lg px-4 py-2 text-sm ${isActive
                ? "bg-white text-gray-900 shadow font-semibold"
                : "bg-gray-700 text-white hover:bg-gray-600"}`
            }
          >
            Elections
          </NavLink>
          <NavLink to="/properties" className={({isActive}) => `rounded-t-lg px-4 py-2 text-sm ${isActive ? "bg-white text-gray-900 shadow font-semibold" : "bg-gray-700 text-white hover:bg-gray-600"}`}>Properties</NavLink>
        </nav>

        <div className="xl:ml-auto relative">
          <button type="button" className="btn btn-sm btn-primary m-0" onClick={() => setContactOpen(true)}>
            Contact
          </button>
        </div>
      </div>
      {contactOpen && <ContactDialog onClose={() => setContactOpen(false)} />}
    </header>
  );
}

export default Header;
